import {Typography, styled} from '@mui/material'
import React, {CSSProperties, HTMLAttributes} from 'react'

import {dataTestId} from '../../../common'

// TODO change it to theme color when moving to fundamental theming system
const NOTIFICATION_RED = '#DA0901'

const StyledNotificationDiv = styled('div')(({theme}) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  zIndex: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: NOTIFICATION_RED,
  color: theme.palette.common.white,
  minWidth: theme.spacing(3),
  minHeight: theme.spacing(3),
  borderRadius: '100%',
  boxSizing: 'content-box'
}))

interface NotificationBadgeProps extends HTMLAttributes<HTMLDivElement> {
  value: number
  testId: string
  styles?: {notification?: CSSProperties}
}

export const NotificationBadge = React.forwardRef<HTMLDivElement, NotificationBadgeProps>(
  ({value, testId, styles, ...rest}, ref) => {
    return (
      <StyledNotificationDiv
        {...rest}
        ref={ref}
        style={styles?.notification}
        {...dataTestId(testId)}
      >
        <Typography variant="body2" component="span">
          {value}
        </Typography>
      </StyledNotificationDiv>
    )
  }
)

NotificationBadge.displayName = 'NotificationBadge'
